import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Typography } from '@mui/material'

import { GlobalAlerts, GlobalNotifications } from 'components/core/Alert'
import { usePermissions } from 'hooks/usePermissions'
import { useAppSelector } from 'redux/hooks'

import { COMPONENT_EXTENDER } from 'extender'

import { useStyles } from './styles'

const SpecialOffers = COMPONENT_EXTENDER('components/core/Cards/SpecialOffers')
const ReferralProgram = COMPONENT_EXTENDER('components/core/Cards/ReferralsCard/ReferralProgram')
const HomePageLayout = COMPONENT_EXTENDER('components/layouts/HomePageLayout')
const RecentTransactions = COMPONENT_EXTENDER('components/core/Transactions/RecentTransactions')
const Sections = COMPONENT_EXTENDER('components/core/Sections/Sections-component')
const OnboardingWizard = COMPONENT_EXTENDER('components/core/Wizard/OnboardingWizard')

const AccountPage: FC = () => {
    const style = useStyles()
    const { t } = useTranslation()
    const { getPermission } = usePermissions()

    const { currentUser } = useAppSelector(state => state.user)
    const { dashboard: selectDashboard } = useAppSelector(state => state.dashboard)
    const { currencies } = useAppSelector(state => state.currencies)

    const { isCompany } = { ...currentUser }

    const isPersonal = !isCompany
    const onboarding = getPermission('Onboarding')
    const enableWizard = getPermission('EnableWizard')

    useEffect(() => {
        // If user was in preview mode and now came back to verify or was verified, remove the flag
        if (!!currentUser && localStorage.getItem('isUserInPreviewMode') === 'true') {
            localStorage.removeItem('isUserInPreviewMode')
        }
    }, [currentUser])

    if (!currentUser && !selectDashboard?.some(Boolean)) {
        return <></>
    }

    return (
        <HomePageLayout page="account" loadingContent={!currentUser || !selectDashboard || !currencies}>
            {onboarding || enableWizard ? (
                <OnboardingWizard onboarding={onboarding} />
            ) : (
                <>
                    <Typography variant="h1" classes={{ root: style.accountHeader }}>
                        {t('Pages.account.Title')}
                    </Typography>
                    <GlobalAlerts />
                    <GlobalNotifications />
                    {/* {(!!quickDepositAsset || getPermission('DigitalAssets')) && <QuickDeposit />} */}
                    {isPersonal && getPermission('PlaygroundEnabled') && <SpecialOffers />}
                    {isPersonal && getPermission('ReferralProgram') && <ReferralProgram showCloseButton component="offerCard" />}
                    <div className={style.recentTransactions}>
                        <RecentTransactions />
                    </div>
                    <Sections dashboard={selectDashboard?.[0]} page="ledgers" />
                </>
            )}
        </HomePageLayout>
    )
}

export default AccountPage
